import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../../baseContainers/BaseDetailsContainer';
import InputTextComponent from '../../components/inputs/InputTextComponent';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import SettingService from '../../services/SettingService';
import FileUploadService from '../../services/FileUploadService';
import YesNoDialog from '../../components/YesNoDialog';
import InputCheckboxComponent from '../../components/inputs/InputCheckboxComponent';
import NotificationService from '../../services/NotificationService';
import PushMessagesCreateRequest from './PushMessagesCreateRequest';
import PushMessagesDetailsResponse from './PushMessagesDetailsResponse';
import InputMultiSelectComponent from '../../components/inputs/InputMultiSelectComponent';
import InputCalendarComponent from '../../components/inputs/InputCalendarComponent';
import ImageComponent from '../../components/inputs/ImageComponent';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import InputLanguageDropdownComponent from '../../components/inputs/InputLanguageDropdownComponent';
import PublishToCompaniesDialog from '../../components/PublishToCompaniesDialog';
import PublishedToCompaniesList from '../../components/PublishedToCompaniesList';

class PushMessagesContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new NotificationService());
        this.fileUploadService = new FileUploadService();
        this.state = {
            viewMode: props.viewMode,
            loading: true,
            elementId: props.elementId,
            locale: props.locale,
            supportedLocales: [],
            element: {
                translations: [],
                selectedProfessionalStatuses: [],
                selectedAge: [],
                selectedLivingPlaces: [],
            },
            proffesionalStatuses: [],
            userAge: [],
            userLivingPlaces: [],
            parameters: [],
            showPublishDialog: false,
            showPublishToCompaniesDialog: false,
            showConfirmRemoveDialog: false,
            sendNotificationToAll: true,
            sendNotificationToSelected: null,
        };
        this.settingService = new SettingService();
        this.fileUploadService = new FileUploadService();
        this.editorRef = React.createRef();
        this.renderlocaleuages = this.renderlocaleuages.bind(this);
        this.changeLanguage = this.changeLanguage.bind(this);
        this.reUpdateElement = this.beforeUpdateElement.bind(this);
        this.handlePublish = this.handlePublish.bind(this);
        this.handlePublishToCompanies = this.handlePublishToCompanies.bind(this);
        this.uploadPhotoHandler = this.uploadPhotoHandler.bind(this);
        this.publish = this.publish.bind(this);
        this.publishToCompanies = this.publishToCompanies.bind(this);
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    updateElement(data) {
        this.setState(
            {
                sendNotificationToAll: true,
                sendNotificationToSelected: data.sendNotificationToSelected,
                element: PushMessagesDetailsResponse.copy(this.state.element, data),
            },
            () => {
                this.initAfterSetElement();
            }
        );
        if (data.status === 'ACTIVE' || data.status === 'REMOVED') {
            this.setState({
                viewMode: 'VIEW',
            });
        }
    }

    prepareHeaderItems() {
        const {backUrl} = this.props;
        return [
            {
                customRenderFunction: this.renderlocaleuages,
                rendered: true,
                className: 'float-left',
            },
            {
                label: t('global.back'),
                // href: AppPrefixUtils.locationHrefUrl(backUrl),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                },
                className: 'gray float-right',
                rendered: true,
            },
        ];
    }

    prepareFooterItems() {
        const {backUrl} = this.props;
        const viewMode = this.viewMode() ? this.viewMode() : this.props.viewMode;
        const {editUrl} = this.props;
        const editHref = `${editUrl}/${this.props.elementId}/`+sessionStorage.getItem('i18nextLng');
        return [
            {
                label: t('global.save'),
                className: 'float-left',
                onClick: this.handleFormSubmit,
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('global.cancel'),
                // href: AppPrefixUtils.locationHrefUrl(backUrl),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(backUrl));
                },
                className: 'gray',
                rendered: viewMode === 'NEW' || viewMode === 'EDIT',
            },
            {
                label: t('pushMsg.edit'),
                // href: AppPrefixUtils.locationHrefUrl(editHref),
                onClick: () => {
                    this.props.history.push(AppPrefixUtils.locationHrefUrl(editHref));
                },
                iconName: 'mdi-pencil',
                className: 'float-right',
                rendered: this.state.element.status === 'DRAFT' && viewMode === 'VIEW',
                // rendered: viewMode === 'VIEW',
            },
            {
                label: t('pushMsg.publish'),
                onClick: this.handlePublish,
                className: 'float-right',
                iconName: 'mdi-publish',
                rendered: this.state.element.status === 'DRAFT' && viewMode === 'VIEW',
            },
            {
                label: 'Publikuj do wielu',
                onClick: this.handlePublishToCompanies,
                className: 'float-right',
                iconName: 'mdi-publish',
                rendered:
                    (this.state.element.status === 'ACTIVE' || this.state.element.status === 'SENT') &&
                    viewMode === 'VIEW' &&
                    this.authService.isUserInRole('ROLE_SUPER_ADMINISTRATOR'),
            },
            {
                label: t('pushMsg.remove'),
                onClick: this.handleRemove.bind(this),
                className: 'float-right',
                iconName: 'mdi-delete',
                rendered: (viewMode === 'VIEW' && (this.state.element.status === 'DRAFT' || this.state.element.status === 'ACTIVE')),
            },
            
        ];
    }
    setElement() {
        const {viewMode} = this.props;
        const {elementId, locale} = this.state;
        this.beforeUpdateElement(viewMode, elementId, locale);
    }

    beforeUpdateElement(viewMode, elementId, locale) {
        console.log('---', viewMode, elementId, locale);

        if (elementId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();

            this.service
                .get(elementId, locale)
                .then((data) => {
                    this.setState({loading: false, locale, elementId}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }

    initBeforeSetElement() {
        this.settingService
            .getSupportedLocales()
            .then((supportedLocales) => {
                this.setState({
                    supportedLocales,
                    element:
                        this.props.viewMode === 'NEW'
                            ? new PushMessagesCreateRequest(this.props.locale, supportedLocales)
                            : new PushMessagesDetailsResponse(supportedLocales),
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getSupportedLocalesError'));
            });

        this.enumService
            .getLocalizedEnumList('UserProfessionalStatus')
            .then((proffesionalStatuses) =>
                this.setState({
                    proffesionalStatuses,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('pushMsg.profesionalStatusError'));
            });

        this.enumService
            .getLocalizedEnumList('UserAge')
            .then((userAge) =>
                this.setState({
                    userAge,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('pushMsg.userAgeError'));
            });

        this.enumService
            .getLocalizedEnumList('UserLivingPlace')
            .then((userLivingPlaces) =>
                this.setState({
                    userLivingPlaces,
                })
            )
            .catch(() => {
                this.showErrorMessage(t('pushMsg.livingPlaceError'));
            });
    }

    handleEditMode() {
        this.setState({
            viewMode: 'EDIT',
        });
    }

    handleRemove() {
        this.setState({
            showConfirmRemoveDialog: true,
        });
    }
    uploadPhotoHandler(uploadedFile) {
        if(uploadedFile != null){
        this.setState((prevState) => ({
            uploadedFile,
            element: {
                ...prevState.element,
                photoTemporaryFileUrl: uploadedFile?.uuid,
            },
        }));
    }
    }
    remove(type, costam, target) {
        if (target.value) {
            this.scrollToTop();
            this.service
                .removeNotification(this.state.elementId)
                .then(() => {
                    const {backUrl} = this.props;
                    this.blockUi();
                    this.persistMessage('success', '', t('pushMsg.successRemove'));
                    // window.location.href = backUrl;
                    this.props.history.push(backUrl);
                })
                .catch(() => {
                    this.setState({showConfirmRemoveDialog: false});
                    this.showErrorMessage(t('pushMsg.removeError'));
                    this.unblockUi();
                });
        } else {
            this.setState({showConfirmRemoveDialog: false});
        }
    }

    handlePublish() {
        console.log('publish');
        this.setState({
            showPublishDialog: true,
        });
    }

    handlePublishToCompanies() {
        this.setState({
            showPublishToCompaniesDialog: true,
        });
    }

    publish(type, costam, target) {
        if (target.value) {
            this.scrollToTop();

            this.blockUi();
            if (this._isMounted) {
                this.service
                    .publish(this.state.elementId)
                    .then(() => {
                        const {backUrl} = this.props;
                        this.blockUi();
                        this.persistMessage('success', '', t('pushMsg.publishSuccess'));
                        // window.location.href = backUrl;
                        this.props.history.push(backUrl);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                        this.setState({showPublishDialog: false});
                        this.unblockUi();
                    });
            }
        } else {
            this.setState({showPublishDialog: false});
        }
    }

    publishToCompanies(externalIds) {
        this.scrollToTop();
        this.blockUi();
        this.service
            .publishToCompanies(this.state.elementId, {externalIds})
            .then(() => {
                const {backUrl} = this.props;
                this.persistMessage('success', '', 'Push zostal opublikowany do wybranych firm.');
                this.props.history.push(backUrl);
            })
            .catch((err) => {
                this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                this.setState({showPublishToCompaniesDialog: false});
                this.unblockUi();
            });
    }

    getAddSucces() {
        return t('pushMsg.createSuccess');
    }

    getUpdateSucces() {
        return t('pushMsg.updateSuccess');
    }

    prepareElementBeforeRequest(element) {
        element.selectedAge = element.selectedAge.map((i) => i.enumValue).filter((x) => x != null);
        element.selectedProfessionalStatuses = element.selectedProfessionalStatuses.map((i) => i.enumValue).filter((x) => x != null);
        element.selectedLivingPlaces = element.selectedLivingPlaces.map((i) => i.enumValue).filter((x) => x != null);
        return element;
    }

    createOrUpdate() {
        const {element} = this.state;
        const {elementId, locale} = this.state;

        element.translations = Object.assign({}, element.translations);
        const request = this.prepareElementBeforeRequest(JSON.parse(JSON.stringify(element)));

        this.scrollToTop();

        if (this._isMounted) {
            if (!elementId) {
                this.service
                    .add(request)
                    .then((response) => {
                        this.afterAddSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            } else {
                this.service
                    .update(request, locale, elementId)
                    .then((response) => {
                        this.afterUpdateSuccess(response);
                    })
                    .catch((err) => {
                        this.props.handleError ? this.props.handleError(err) : this.showErrorMessage(err.message, 10000);
                    });
            }
        }
    }

    changeLanguage(a, b, c) {
        const {editUrl} = this.props;
        const {elementId} = this.state;
        const locale = c.value;
        // window.location.href = AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale);
        this.props.history.push(AppPrefixUtils.locationHrefUrl(editUrl + '/' + elementId + '/' + locale));
        this.beforeUpdateElement('VIEW', elementId, locale);
    }

    renderlocaleuages() {
        return (
            <InputLanguageDropdownComponent
                id='locale'
                name='locale'
                label={t('global.languageChooser')}
                validator={this.validator}
                validators='not_required'
                value={this.state.locale}
                options={this.state.supportedLocales}
                colClass='col-xl-1 col-lg-3 col-md-4 col-sm-5'
                viewMode={'EDIT'}
                onChange={this.handleChange}
                rendered
                showClear={false}
                stateField={``}
            />
        );
    }

    getBackLabel() {
        return t('global.backToList');
    }

    render() {
        return (
            <div className='container-fluid pushMsg-container'>
                <YesNoDialog
                    onChange={this.publish}
                    visible={this.state.showPublishDialog}
                    header={t('pushMsg.publishHeader')}
                    name='visible'
                    onHide={() => {
                        this.setState({showPublishDialog: false});
                    }}
                >
                    <span>{t('pushMsg.publishBody')}</span>
                </YesNoDialog>
                <PublishToCompaniesDialog
                    visible={this.state.showPublishToCompaniesDialog}
                    header='Publikuj push do wielu firm'
                    body='Wybierz firmy, do ktorych chcesz opublikowac ten push.'
                    onHide={() => {
                        this.setState({showPublishToCompaniesDialog: false});
                    }}
                    onPublish={this.publishToCompanies}
                />
                <YesNoDialog
                    onChange={this.remove.bind(this)}
                    visible={this.state.showConfirmRemoveDialog}
                    header={t('pushMsg.removeTitle')}
                    name='visible'
                    onHide={() => {
                        this.setState({showConfirmRemoveDialog: false});
                    }}
                >
                    <span>{t('pushMsg.removeBody')}</span>
                </YesNoDialog>
                {this.renderView()}
            </div>
        );
    }
    getContainerListName() {
        return 'pushMsg-list-container';
    }

    breadCrumbItems() {
        return [
            {name: t('pushMsg.name'), url: '/pushMsg-list'},
            {name: t('pushMsg.details'), url: ``},
        ];
    }
    viewMode() {
        const {viewMode} = this.props;
        return viewMode === 'NEW' ? viewMode : this.state?.element?.status?.value === 'DRAFT' && viewMode === 'EDIT' ? 'EDIT' : 'VIEW';
    }

    renderDetails() {
        const {locale} = this.state;
        return (
            <React.Fragment>
                <div className='row'>
                    <PublishedToCompaniesList
                        companies={this.state.element?.publishedToCompanies}
                        rendered={this.authService.isUserInRole('ROLE_SUPER_ADMINISTRATOR')}
                    />
                        <InputTextComponent
                            id={`${locale}-title`}
                            name='title'
                            label={t('pushMsg.title')}
                            colClass='col-md-8'
                            value={this.state.element?.translations[locale]?.title}
                            validator={this.validator}
                            validators='required|max:128'
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                            stateField={`element.translations[${locale}]`}
                        />

                        <InputCalendarComponent
                            id={'publishDate'}
                            name='publishDate'
                            label={t('pushMsg.setPublishDate')}
                            value={this.state.element.publishDate}
                            validator={this.validator}
                            validators={'required'}
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                            dateFormatMoment='DD-MM-YYYY HH:mm'
                            showTime
                            showIcon
                            minDate={new Date()}
                        />
                    <InputTextComponent
                        id={`description`}
                        name='description'
                        label={t('pushMsg.description')}
                        colClass='col-md-12'
                        value={this.state.element?.translations[this.state.locale]?.description}
                        validator={this.validator}
                        validators='required|max:255'
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                        stateField={`element.translations[${locale}]`}
                    />

                    <div>
                        <div className=' row p-label'>
                            <label>{this.props.type === 'ACHIEVEMENT' ? t('achievement.photo') : t('challenge.photo')}</label>
                        </div>

                        <ImageComponent
                            key='push-photo'
                            srcUrl={`${this.service.getPath()}/attachment/${
                                this.state.element?.photo?.uuid
                            }?token=${this.authService?.getToken()}`}
                            alt='Action photo'
                            handleRemove={(e) => {
                                this.setState((prevState) => ({
                                    element: {
                                        ...prevState.element,
                                        photo: null,
                                        removePhoto: true,
                                    },
                                }));
                            }}
                            notValidImageTypeErrorMessage={() => {
                                this.showErrorMessage(t('image.notValidImageType'));
                            }}
                            errorMessage={this.showErrorMessage}
                            imgMaxSizeParameter={this.state.imgMaxSizeParameter}
                            fileSizeToTranslation={this.state.fileSizeToTranslation}
                            attachment={this.state.element.photo}
                            setFile={this.uploadPhotoHandler}
                            t={t}
                            required={true}
                            validator={this.validator}
                            viewMode={this.viewMode()}
                            fileUploadService={this.fileUploadService}                            
                        />
                    </div>

                    <div>
                        {(this.state.sendNotificationToAll === true && this.props.viewMode === 'VIEW') ||
                        this.props.viewMode === 'EDIT' ||
                        this.props.viewMode === 'NEW' ? (
                            <div className=' row p-label'>
                                <label>{t('pushMsg.sendNotificationToAll')}</label>{' '}
                            </div>
                        ) : null}
                        <InputCheckboxComponent
                            id='sendNotificationToAll'
                            name='sendNotificationToAll'
                            //label={t('pushMsg.sendNotificationToAll')}
                            labelLeftStyle
                            value={
                                this.props.viewMode === 'VIEW' ? this.state.sendNotificationToAll : this.state.element.sendNotificationToAll
                            }
                            validator={this.validator}
                            validators='required'
                            colClass='col-lg-6 col-md-12 col-sm-12'
                            disabled={true}
                            onChange={this.handleChange}
                            viewMode={'EDIT'}
                            onAfterStateChange={() =>
                                this.setState((prevState) => ({
                                    element: {
                                        ...prevState.element,
                                        selectedProfessionalStatuses: [],
                                        selectedAge: [],
                                        selectedLivingPlaces: [],
                                        sendNotificationToSelected: false,
                                    },
                                }))
                            }
                            rendered={
                                (this.state.sendNotificationToAll === true && this.props.viewMode === 'VIEW') ||
                                this.props.viewMode === 'EDIT' ||
                                this.props.viewMode === 'NEW'
                            }
                        />{' '}
                    </div>

                    <div className='form-group'>
                        <div className='p-label push-recipient-el-label'>
                            {false ? (
                                <div>
                                    <div className=' row p-label'>
                                        {' '}
                                        <label>{t('pushMsg.sendNotificationToSelected') + ' *'}</label>
                                    </div>

                                    <InputMultiSelectComponent
                                        id='selectedProfessionalStatuses'
                                        name='selectedProfessionalStatuses'
                                        //colClass='col-12'
                                        colClass='col-md-12'
                                        label={t('pushMsg.proffesionalStatus')}
                                        placeholder={t('global.choose')}
                                        value={this.state.element?.selectedProfessionalStatuses}
                                        validator={this.validator}
                                        validators={'not_required'}
                                        onChange={this.handleChange}
                                        viewMode={this.props.viewMode}
                                        options={this.state.proffesionalStatuses[`${this.state.locale}`]}
                                        dataKey='enumValue'
                                        optionLabel='label'
                                        filter
                                        filterBy='label'
                                        rendered={!this.state.sendNotificationToAll || !this.state.element.sendNotificationToAll}
                                        validateViewMode
                                        onAfterStateChange={() =>
                                            this.setState((prevState) => ({
                                                element: {
                                                    ...prevState.element,
                                                    sendNotificationToSelected: true,
                                                },
                                            }))
                                        }
                                    />
                                    <InputMultiSelectComponent
                                        id='selectedAge'
                                        name='selectedAge'
                                        colClass='col-12'
                                        // colClass='col-md-12'
                                        label={t('pushMsg.age')}
                                        placeholder={t('global.choose')}
                                        value={this.state.element?.selectedAge}
                                        validator={this.validator}
                                        validators={'not_required'}
                                        onChange={this.handleChange}
                                        viewMode={this.props.viewMode}
                                        options={this.state.userAge[`${this.state.locale}`]}
                                        dataKey='label'
                                        optionLabel='label'
                                        filter
                                        filterBy='name'
                                        enumMode={true}
                                        rendered={!this.state.sendNotificationToAll || !this.state.element.sendNotificationToAll}
                                        validateViewMode
                                        onAfterStateChange={() =>
                                            this.setState((prevState) => ({
                                                element: {
                                                    ...prevState.element,
                                                    sendNotificationToSelected: true,
                                                },
                                            }))
                                        }
                                    />

                                    <InputMultiSelectComponent
                                        id='selectedLivingPlaces'
                                        name='selectedLivingPlaces'
                                        colClass='col-12'
                                        label={t('pushMsg.livingPlace')}
                                        placeholder={t('global.choose')}
                                        value={this.state.element?.selectedLivingPlaces}
                                        validator={this.validator}
                                        validators={'not_required'}
                                        onChange={this.handleChange}
                                        viewMode={this.props.viewMode}
                                        options={this.state.userLivingPlaces[`${this.state.locale}`]}
                                        dataKey='label'
                                        optionLabel='label'
                                        filter
                                        filterBy='name'
                                        enumMode={true}
                                        rendered={!this.state.sendNotificationToAll || !this.state.element.sendNotificationToAll}
                                        validateViewMode
                                        onAfterStateChange={() =>
                                            this.setState((prevState) => ({
                                                element: {
                                                    ...prevState.element,
                                                    sendNotificationToSelected: true,
                                                },
                                            }))
                                        }
                                    />
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

PushMessagesContainer.defaultProps = {
    backUrl: '/pushMsg-list',
    editUrl: '/pushMsg/edit',
    cancelUrl: '/pushMsg-list',
    lazy: true,
};

PushMessagesContainer.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    editUrl: PropTypes.string,
};

export default withRouter(withTranslation()(PushMessagesContainer));
